import React from "react";
import { observer, inject } from "mobx-react";
import { ISearchStore, IEntities } from "@src/Stores/Search/types";
import LocationsTable from "../../Locations/LocationsContent/LocationTable/LocationsTable";
import OrganisationsTable from "../../Organisations/OrganisationsContent/OrganisationsTable/OrganisationsTable";
import PermissionsTable from "../../Permissions/PermissionsContent/PermissionsTable/PermissionsTable";
import PermissionGroupsTable from "../../PermissionGroups/PermissionGroupsContent/PGTable/PGTable";
import PositionsTable from "../../Positions/PositionsContent/PositionsTable/PositionsTable";
import PersonsTable from "../../Persons/PersonsContent/PersonsTable/PersonsTable";
import { computed } from "mobx";
import { Values } from "@src/Tools/Values";
import { STTypographyGlobalSearch, STHeaderWrapper, STMainContentWrapper } from "./styles";
import { Grid } from "@material-ui/core";

import PinDrop from "@material-ui/icons/PinDrop";
import Business from "@material-ui/icons/Business";
import Lock from "@material-ui/icons/Lock";
import GroupWork from "@material-ui/icons/GroupWork";
import Work from "@material-ui/icons/Work";
import People from "@material-ui/icons/People";
import { IValuesStore } from "@src/Stores/Values/types";
import ThemesTable from "../../Themes/ThemesContent/ThemesTable/ThemesTable";
import PositionTeamsTable from "../../PositionTeams/PositionTeamsContent/PositionTeamsTable/PositionTeamsTable";

interface IProps {
  search?: ISearchStore;
  values?: IValuesStore;
}

@inject("search", "values")
@observer
export default class TablesList extends React.Component<IProps> {
  @computed get resultsAreEmpty() {
    if (this.props.search.globalSearchActive) {
      return Object.keys(this.props.search.filteredEntities).every(
        (entityKey: keyof IEntities) =>
          this.props.search.filteredEntities[entityKey] == null || this.props.search.filteredEntities[entityKey].length === 0
      );
    }
    return false;
  }

  renderTable(entity: keyof IEntities) {
    switch (entity) {
      case "locations":
        return this.props.search.filteredEntities[entity].length ? (
          <div key="locTableEntity">
            <STHeaderWrapper>
              <Grid container>
                <Grid item>
                  <PinDrop nativeColor="rgba(0, 0, 0, 0.54)" />
                </Grid>
                <Grid item>
                  <STTypographyGlobalSearch variant="h6">
                    {Values.getLocalizationValue("locations")}
                  </STTypographyGlobalSearch>
                </Grid>
              </Grid>
            </STHeaderWrapper>
            <LocationsTable
              locations={this.props.search.filteredEntities[entity]}
            />
          </div>
        ) : null;
      case "organisations":
        return this.props.search.filteredEntities[entity].length ? (
          <div key="orgTableEntity">
            <STHeaderWrapper>
              <Grid container>
                <Grid item>
                  <Business nativeColor="rgba(0, 0, 0, 0.54)" />
                </Grid>
                <Grid item>
                  <STTypographyGlobalSearch variant="h6">
                    {Values.getLocalizationValue("organisations")}
                  </STTypographyGlobalSearch>
                </Grid>
              </Grid>
            </STHeaderWrapper>
            <OrganisationsTable
              organisations={this.props.search.filteredEntities[entity]}
            />
          </div>
        ) : null;
      case "permissions":
        return this.props.search.filteredEntities[entity].length ? (
          <div key="permTableEntity">
            <STHeaderWrapper>
              <Grid container>
                <Grid item>
                  <Lock nativeColor="rgba(0, 0, 0, 0.54)" />
                </Grid>
                <Grid item>
                  <STTypographyGlobalSearch variant="h6">
                    {Values.getLocalizationValue("permissions")}
                  </STTypographyGlobalSearch>
                </Grid>
              </Grid>
            </STHeaderWrapper>
            <PermissionsTable
              permissions={this.props.search.filteredEntities[entity]}
            />
          </div>
        ) : null;
      case "permissionGroups":
        return this.props.search.filteredEntities[entity].length ? (
          <div key="permGroupTableEntity">
            <STHeaderWrapper>
              <Grid container>
                <Grid item>
                  <GroupWork nativeColor="rgba(0, 0, 0, 0.54)" />
                </Grid>
                <Grid item>
                  <STTypographyGlobalSearch variant="h6">
                    {Values.getLocalizationValue("permissionGroups")}
                  </STTypographyGlobalSearch>
                </Grid>
              </Grid>
            </STHeaderWrapper>
            <PermissionGroupsTable
              permissionGroups={this.props.search.filteredEntities[entity]}
            />
          </div>
        ) : null;
      case "positions":
        return this.props.search.filteredEntities[entity].length ? (
          <div key="posTableEntity">
            <STHeaderWrapper>
              <Grid container>
                <Grid item>
                  <Work nativeColor="rgba(0, 0, 0, 0.54)" />
                </Grid>
                <Grid item>
                  <STTypographyGlobalSearch variant="h6">
                    {Values.getLocalizationValue("positions")}
                  </STTypographyGlobalSearch>
                </Grid>
              </Grid>
            </STHeaderWrapper>
            <PositionsTable
              positions={this.props.search.filteredEntities[entity]}
            />
          </div>
        ) : null;
        case "positionTeams":
          return this.props.search.filteredEntities[entity].length ? (
            <div key="posTeamsTableEntity">
              <STHeaderWrapper>
                <Grid container>
                  <Grid item>
                    <Work nativeColor="rgba(0, 0, 0, 0.54)" />
                  </Grid>
                  <Grid item>
                    <STTypographyGlobalSearch variant="h6">
                      {Values.getLocalizationValue("positionTeams")}
                    </STTypographyGlobalSearch>
                  </Grid>
                </Grid>
              </STHeaderWrapper>
              <PositionTeamsTable
                positionTeams={this.props.search.filteredEntities[entity]}
              />
            </div>
          ) : null;
      case "persons":
        return this.props.search.filteredEntities[entity].length ? (
          <div key="persTableEntity">
            <STHeaderWrapper>
              <Grid container>
                <Grid item>
                  <People nativeColor="rgba(0, 0, 0, 0.54)" />
                </Grid>
                <Grid item>
                  <STTypographyGlobalSearch variant="h6">
                    {Values.getLocalizationValue("persons")}
                  </STTypographyGlobalSearch>
                </Grid>
              </Grid>
            </STHeaderWrapper>
            <PersonsTable
              persons={this.props.search.filteredEntities[entity]}
            />
          </div>
        ) : null;
      case "themes":
        return this.props.search.filteredEntities[entity].length ? (
          <div key="themesTableEntity">
            <STHeaderWrapper>
              <Grid container>
                <Grid item>
                  <People nativeColor="rgba(0, 0, 0, 0.54)" />
                </Grid>
                <Grid item>
                  <STTypographyGlobalSearch variant="h6">
                    {Values.getLocalizationValue("themes")}
                  </STTypographyGlobalSearch>
                </Grid>
              </Grid>
            </STHeaderWrapper>
            <ThemesTable themes={this.props.search.filteredEntities[entity]} />
          </div>
        ) : null;

      default:
        break;
    }
  }

  render() {
    if (this.resultsAreEmpty) {
      return (
        <Grid container justify="center" alignContent="center">
          {Values.getLocalizationValue("thereAreNoItems")}
        </Grid>
      );
    }
    return  (
      <STMainContentWrapper>
        {Object.keys(this.props.search.filteredEntities).map(
          (entity: keyof IEntities) => this.renderTable(entity)
        )}
      </STMainContentWrapper>
    )
  }
}
